import { render } from "./Svgicon.vue?vue&type=template&id=48cbc377"
import script from "./Svgicon.vue?vue&type=script&lang=js"
export * from "./Svgicon.vue?vue&type=script&lang=js"

import "./Svgicon.vue?vue&type=style&index=0&id=48cbc377&lang=css"

import exportComponent from "/Users/andersnielsen/Sites/demo-leverandoroverblik/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__